<ng-http-loader
  [filteredUrlPatterns]="dontUseLoaderOnRoutes"
  [entryComponent]="loader"
>
</ng-http-loader>
<!-- Fullscreen spinner overlay -->
@if (showAiLoader) {
  <app-ai-elearnio-loader
    class="fullscreen-spinner"
    (cancelLoader)="handleCancelAiSpinner()"
  ></app-ai-elearnio-loader>
}
@if (isLoggedIn) {
  <app-header
    [ngClass]="{ hide: !showHeader }"
    [currentMember]="member"
    [isDefaultBrandColor]="isDefaultBrandColor()"
    [logo]="logo"
    [showGamificationBadge]="showGamificationBadge"
  ></app-header>
  <main
    class="main-layout overflow-y-auto"
    [class.full-height]="!showHeader"
    [class.safari]="isSafari"
    [class.reporting-route]="section === SECTIONS.REPORTING"
    ngClass.lt-md="mobile"
  >
    <div
      fxLayout="column"
      class="content-container"
      ngClass.gt-md="desktop-minimum-width"
    >
      <div
        class="height-auto"
        [class.mobile]="mobileQuery.matches"
        fxFlex="grow"
      >
        <mat-drawer-container
          [ngClass]="{
            'reporting-route': section === SECTIONS.REPORTING,
            safari: isSafari,
          }"
        >
          @if (mobileQuery.matches || (showBars && !hideSidebar)) {
            <mat-drawer
              #snav
              [mode]="mobileQuery.matches ? 'over' : 'side'"
              [opened]="!mobileQuery.matches && showBars"
              ngClass.lt-md="mobile"
              [class.expanded]="isSidebarExpanded"
            >
              @if (member && !mobileQuery.matches && !hideSidebar) {
                <app-sidebar
                  [member]="member"
                  [section]="section"
                  [companySettings]="companySettings"
                  [isSidebarExpanded]="isSidebarExpanded"
                  (sidebarClick)="onSidebarClick($event)"
                >
                </app-sidebar>
              }
              @if (member && mobileQuery.matches) {
                <app-navigation-sidebar
                  [isAdmin]="isAdmin"
                  [showGamificationBadge]="showGamificationBadge"
                >
                </app-navigation-sidebar>
              }
            </mat-drawer>
          }
          <mat-drawer-content
            [class.expanded]="isSidebarExpanded"
            [class.has-sidebar]="
              !mobileQuery.matches && showBars && !hideSidebar
            "
          >
            <app-toolbar
              [section]="section"
              [breadcrumbs]="breadcrumbs"
              [disableActions]="disableActions"
              [hideActions]="hideActions"
              [enableLoginUsername]="!!companySettings?.enableLoginUsername"
              [hideMenuButton]="hideMenuButton"
              [customNewButtonRouterLinks]="customNewButtonRouterLinks"
              (actionOne)="actionOne()"
              (actionTwo)="actionTwo()"
              (actionThree)="actionThree()"
              (actionFour)="actionFour()"
              (actionFilter)="doFilters($event)"
              (resetFilters)="resetFilters()"
            >
            </app-toolbar>
            <div class="router-outler-wrapper-relative">
              <div class="router-outlet-wrapper">
                <router-outlet></router-outlet>
              </div>
            </div>
          </mat-drawer-content>
        </mat-drawer-container>
      </div>
    </div>
  </main>
} @else {
  <router-outlet></router-outlet>
}

<app-notification-modal-dialog></app-notification-modal-dialog>
